import React, { useState, useEffect } from "react";
import { Typography, Grid, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { commonService } from "../../../../../services";
import { useTranslation } from "react-i18next";
import { Skeleton } from '@material-ui/lab'
const useStyles = makeStyles((theme) => ({
  imgHeight: {
    height: "35vh",
    marginBottom: "8%",
  },
  blueText: {
    color: theme.palette.ePrimary?.base,
  },
}));
export default function SearchNoResult({ searchContent, contentReady }) {
  let classes = useStyles();
  const [searchNotFound, setSearchNotFound] = useState();
  const [searchTryAgain, setSearchTryAgain] = useState();
  const searchImg = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_SEARCH_NOT_FOUND
  );
  const {t:labels, ready: labelReady} = useTranslation("label-E_SEARCH_RESULT");
  const [assets, setAssets] = useState();

  useEffect(() => {
    if (searchImg) {
      commonService.getAssestUrl(searchImg).then((response) => {
        setAssets(response);
      });
    }
  }, [searchImg]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={1}
    >
      <Grid item>
       {assets && <img src={assets?.assetPath} alt={labelReady ? labels([assets?.fallBackLabelKey]) : ''} className={classes.imgHeight} />}
      </Grid>
      <Grid item>
      {
        contentReady ?
        <Typography align="center" variant="h4" className={classes.blueText}>
          <strong>{searchContent("E_SEARCH_NO_RESULT_FOUND").answer}</strong>
        </Typography>
        : <Skeleton />
      }
      </Grid>
      <Grid item>
      {
        contentReady ?
        <Typography
          align="center"
          variant="h5"
          className={classes.blueText}
        >
          {searchContent("E_SEARCH_TRY_ANOTHER").answer}
        </Typography>
        : <Skeleton />
      }
      </Grid>
    </Grid>
  );
}
